import React from "react";
import styles from "./DocumentCard.module.css";
import doc_icon from "assets/images/doc_icon.png";
import { Typography } from "@mui/material";
import { extractDocType } from "utils/helpers";
import documents from "utils/documents";

function DocumentCard({ document }) {
  return (
    <div className={styles.document_card}>
      <div className={styles.body}>
        <img src={doc_icon} alt="document" />
      </div>
      <div className={styles.footer}>
        <div className={styles.pdf_icon}>{extractDocType(document?.url)}</div>
        <div className={styles.document_card_text}>
          <Typography noWrap textOverflow="clip">
            {documents?.filter((doc) => doc?.value === document?.type)[0].label}
          </Typography>
        </div>
        {/* <div className={styles.document_card_time}></div> */}
      </div>
    </div>
  );
}

export default DocumentCard;

// Reverse string
